module.exports = __webpack_public_path__ + "assets/media/drift_salesloft_brand_logo.f5e86de9.svg";